module.exports = __webpack_public_path__ + "static/media/warning_icon_red.96239639.svg";